import React, { useState, useEffect } from 'react';
import { OffersBlock } from '@coog/react-components';
import { get, map, isEmpty, isEqual, find, filter, reduce, cloneDeep, findLast, forEach } from 'lodash-es';
import { advancementStatusEnum } from '../../../Services/SalesRoutes/enum';
import Action from './Action.presentational';

const OffersPresentational = ({
  blockOffers,
  isFinishedSalesRoute,
  contracts,
  advancementStatus,
  //
  partialUpdateSalesRouteContract,
  partialUpdateSalesRouteContractPrint,
  cancelSalesRoute,
  putOnHoldSalesRoute,
  strings,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
}) => {
  // offersBlock
  const [validOffersBlock, setValidOffersBlock] = useState([]);
  const [answersOffersBlock, setAnswersOffersBlock] = useState([]);
  const [total, setTotal] = useState(0);

  // label Button
  const labelNextButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');
  let labelActionButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');
  const labelCancelButton = get(strings, 'editsalesroute.action.button.cancel.label', 'Annuler');
  const labelPutonholdButton = get(strings, 'editsalesroute.action.button.putonhold.label', 'Mettre en attente');
  const labelTotal = get(strings, 'editsalesroute.total.label', 'total');
  // button is spinner
  let isSpinnerNextButton;
  let isSpinnerActionButton;
  // check disable nextButton
  let isDisabledNextButton;
  let isDisabledActionButton = false;

  /**
   * check is valid all offers
   */
  const checkIsValidOffers = () => {
    try {
      const isValidOffers = !reduce(validOffersBlock, (result, item) => get(item, 'isValid') && result, true);
      return isValidOffers;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`checkIsValidOffers ${e.stack}`);
    }
    return false;
  };

  if (isFinishedSalesRoute) {
    // if finished salesRoute
    labelActionButton = get(strings, 'editsalesroute.action.button.printfinalstep.label', `Dossier d'adhésion envoyé`);
    isDisabledNextButton = true;
    isDisabledActionButton = true;
  } else {
    // if not finished salesRoute
    labelActionButton = get(strings, 'editsalesroute.action.button.finalstep.label', `Éditer le dossier d'adhésion`);
    isDisabledNextButton = checkIsValidOffers();
    isDisabledActionButton = checkIsValidOffers();
    // check advancement status
    switch (advancementStatus) {
      case advancementStatusEnum.EVENT_PRINT_SALESROUTE_REQUEST:
        isDisabledActionButton = true;
        isSpinnerActionButton = true;
        break;
      case advancementStatusEnum.EVENT_PRINT_SALESROUTE_SUCCESS:
        labelActionButton = get(
          strings,
          'editsalesroute.action.button.printfinalstep.label',
          `Dossier d'adhésion envoyé`,
        );
        isDisabledActionButton = true;
        break;
      case advancementStatusEnum.EVENT_OFFERS_BLOCK_REQUEST:
        isDisabledNextButton = true;
        isSpinnerNextButton = true;
        break;
      case advancementStatusEnum.EVENT_SUBSCRIPTION_BLOCK_SUCCESS:
        isDisabledNextButton = false;
        break;

      default:
        break;
    }
  }

  /**
   *  handle init ValidOffersBlock
   */
  const initValidOffersBlock = () => {
    try {
      // init validOffersBlock
      const newValidOffersBlock = map(blockOffers, item => {
        const id = get(item, 'id');
        const mandatory = get(item, 'offer.mandatory');
        // create new Object
        let newObject = {
          id,
          isValid: mandatory !== true,
        };
        // check contract Are Defined
        const contractsAreDefined = !isEmpty(contracts);
        if (contractsAreDefined) {
          newObject = {
            id,
            isValid: true,
          };
        }

        return newObject;
      });
      // set ValidOffersBlock
      setValidOffersBlock(newValidOffersBlock);
      setAnswersOffersBlock([]);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`initValidOffersBlock ${e.stack}`);
    }
  };

  /**
   * init answersOffersBlock
   */
  const initAnswersOffersBlock = () => {
    try {
      // init validOffersBlock
      const newAnswersOffersBlock = map(blockOffers, item => {
        // create new Object
        const newObject = {
          answers: get(item, 'offer.formulaSelected'),
          codeProduct: get(item, 'offer.dataOffer.extraData.codeProduct'),
          codeCommercialProduct: get(item, 'offer.dataOffer.extraData.codeCommercialProduct'),
          id: item?.id,
          ref: find(get(item, 'offer.dataOffer.formulas', []), { code: get(item, 'offer.formulaSelected') })?.offerRef,
        };

        return newObject;
      });
      // set AnswersOffersBlock
      setAnswersOffersBlock(newAnswersOffersBlock);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`initAnswersOffersBlock ${e.stack}`);
    }
  };

  /**
   * useEffect => blockOffers
   */
  useEffect(
    () => {
      try {
        // init validOffersBlock
        if (isEmpty(validOffersBlock)) {
          initValidOffersBlock();
        }
        // init AnswersOffersBlock
        if (isEmpty(answersOffersBlock)) {
          initAnswersOffersBlock();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    //
    [blockOffers],
  );

  /**
   * get total Formula selected by offer
   * @param {*} param0
   */
  const getTotalFormulaSelectedByPodium = ({ offer, formulaSelected }) => {
    try {
      // get item data by type 'TOTAL'
      const itemDataByType = findLast(get(offer, 'offer.dataOffer.data'), { type: 'total' });
      // get item data by REF
      const itemPackageByRef = find(get(itemDataByType, 'packages'), { ref: formulaSelected });
      // WARNING: DIRTY HACK
      // TODO: get original values from offer
      const strValue = get(itemPackageByRef, 'value', '0').replace(/\s€/i, '').replace(/\s/i, '').replace(/,/g, '.');
      const totalFormulaSelected = parseFloat(strValue);

      return totalFormulaSelected;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`getTotalFormulaSelectedByPodium ${e.stack}`);
    }
    return 0;
  };

  /**
   * calculate total formulas selected
   */
  const calculateTotalFormulasSelected = () => {
    try {
      let localTotal = 0;
      forEach(blockOffers, item => {
        const codeProduct = get(item, 'offer.dataOffer.extraData.codeProduct');
        const formulaSelected = get(find(answersOffersBlock, { codeProduct, id: item.id }), 'answers');
        if (formulaSelected) {
          localTotal += getTotalFormulaSelectedByPodium({ offer: item, formulaSelected });
        }
      });
      return localTotal.toFixed(2);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`calculateTotalFormulasSelected ${e.stack}`);
    }
    return 0;
  };

  /**
   * useEffect => answersOffersBlock
   */
  useEffect(
    () => {
      try {
        const localTotal = calculateTotalFormulasSelected();
        setTotal(localTotal);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    //
    [answersOffersBlock],
  );

  /**
   * handle Change ValidOffersBlock
   * @param {*} param0
   */
  const handleChangeValidOffersBlock = ({ offer, isValidLocal }) => {
    try {
      let isValid = true;
      if (get(offer, 'offer.mandatory') === true) {
        isValid = isValidLocal === true;
      }
      // get new ValidOffersBlock
      const newValidOffersBlock = map(validOffersBlock, item => {
        if (get(item, 'id') === get(offer, 'id')) {
          return {
            ...item,
            isValid,
          };
        }
        return item;
      });
      setValidOffersBlock(newValidOffersBlock);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`handleChangeValidOffersBlock ${e.stack}`);
    }
  };

  /**
   * handleChange Answers OffersBlock
   * @param {*} answers
   */
  const handleChangeAnswersOffersBlock = ({ offer, answers }) => {
    try {
      let newAnswersOffersBlock = cloneDeep(answersOffersBlock);

      const codeProduct = get(offer, 'offer.dataOffer.extraData.codeProduct');
      // new object
      const newObject = {
        answers,
        codeProduct,
        codeCommercialProduct: get(offer, 'offer.dataOffer.extraData.codeCommercialProduct'),
        id: offer.id,
        ref: find(get(offer, 'offer.dataOffer.formulas', []), { code: answers })?.offerRef,
      };
      // check exist current object in answersOffersBlock
      const existObject = find(answersOffersBlock, { codeProduct, id: offer.id });
      if (existObject) {
        const answersOffersBlockFiltered = filter(
          answersOffersBlock,
          item => get(item, 'codeProduct') !== codeProduct || get(item, 'id') !== offer.id,
        );
        newAnswersOffersBlock = cloneDeep(answersOffersBlockFiltered);
      }

      newAnswersOffersBlock.push(newObject);
      newAnswersOffersBlock = filter(newAnswersOffersBlock, item => !!get(item, 'answers'));

      //
      setAnswersOffersBlock(newAnswersOffersBlock);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`handleChangeAnswersOffersBlock ${e.stack}`);
    }
  };

  const handleEditField = answersLocal => {
    if (answersOffersBlock.length && !isEqual(answersLocal, get(answersOffersBlock, '[0].answers'))) {
      editField();
    }
  };

  const onResetFormLocal = offer => answersLocal => {
    handleChangeAnswersOffersBlock({
      offer,
      answers: answersLocal,
    });
    onResetForm();
  };

  useEffect(() => {
    if (willSaveForm) {
      partialUpdateSalesRouteContract({ answers: answersOffersBlock, saveOnly: true })();
      onSaveForm();
    }
  }, [willSaveForm]);

  return (
    <>
      {map(blockOffers, offer => (
        <div className="offer-block-container" key={`offer-${get(offer, 'id')}`}>
          <OffersBlock
            mandatory={get(offer, 'offer.mandatory')}
            formulaSelectedProp={get(offer, 'offer.formulaSelected')}
            dataOfferProp={get(offer, 'offer.dataOffer')}
            strings={get(offer, 'offer.strings')}
            eventEmitterSelectFormula={event => {
              handleChangeValidOffersBlock({ offer, isValidLocal: get(event, 'isValid') });
              handleChangeAnswersOffersBlock({
                offer,
                answers: get(event, 'answers'),
              });
              handleEditField(get(event, 'answers'));
            }}
            stringsProp={strings}
            willResetForm={willResetForm}
            onResetForm={onResetFormLocal(offer)}
          />
          <hr
            style={{
              marginTop: '20px',
              marginBottom: '10px',
            }}
          />
        </div>
      ))}
      {/* total */}
      <div className="total">
        <div className="card-item">
          <span className="label">{labelTotal}</span>
          <span>=</span>
          <span className="value">{total}</span>
          <span>€</span>
        </div>
      </div>
      {/* action Block */}
      {/* TODO : Use one Action, and pass a list of buttons instead of multiples params */}
      <Action
        isDisabledNextButton={isDisabledActionButton}
        isSpinnerNextButton={isSpinnerActionButton}
        partialUpdateSalesRoute={partialUpdateSalesRouteContractPrint({ answers: answersOffersBlock })}
        cancelSalesRoute={cancelSalesRoute}
        putOnHoldSalesRoute={putOnHoldSalesRoute}
        labelNextButton={labelActionButton}
        labelCancelButton={labelCancelButton}
        labelPutonholdButton={labelPutonholdButton}
      />
      <Action
        isDisabledNextButton={isDisabledNextButton}
        isSpinnerNextButton={isSpinnerNextButton}
        partialUpdateSalesRoute={partialUpdateSalesRouteContract({ answers: answersOffersBlock })}
        labelNextButton={labelNextButton}
      />
    </>
  );
};

OffersPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  contracts: [],
  advancementStatus: undefined,
  strings: {},
  willResetForm: false,
  onResetForm: () => {},
  willSaveForm: false,
  onSaveForm: () => {},
};

export default OffersPresentational;
